import { Filter } from '@fabric-ui/components';
import { escapeFreeTextSpecialChars, unescapeFreeTextSpecialChars } from '../../../utils/filter/filter-utils';

export enum FreeSearchMatchMode {
  Exact = 'exact',
  Substring = 'substring',
}

export const isFreeTextSubstring = (stringValue: string): boolean =>
  stringValue.startsWith('*') && stringValue.endsWith('*') && stringValue.length > 1;

export const createFreeTextFilter = (value: string = '', matchMode: FreeSearchMatchMode = FreeSearchMatchMode.Exact): Filter => ({
  freeText: {
    stringValue: value
      ? matchMode === FreeSearchMatchMode.Substring
        ? `*${escapeFreeTextSpecialChars(value)}*`
        : escapeFreeTextSpecialChars(value)
      : '',
  },
});

export const getFreeTextValue = (filter: Filter): string => {
  const raw = filter.freeText?.stringValue || '';
  return unescapeFreeTextSpecialChars(raw);
};
